import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { BRANDS } from 'shared/constants';
import { useService } from 'shared/providers';
import { BrandContact, Brands } from 'shared/types';

export function useBrandContactInfo(brand: Brands) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();

  const { data, isLoading, isFetching } = useQuery<BrandContact[], Error>(
    ['brand-contact-info', brand],
    () => quoteService.getBrandContactInfo(brand),
    {
      onError: error => {
        enqueueSnackbar(`Could not find contact info for ${BRANDS[brand]}`, { variant: 'error' });
      },
      retry: false,
    }
  );
  return { contactInfo: data, isLoading, isFetching } as const;
}
